import { useLocation } from "react-router-dom";
import { connect } from "react-redux"
import { useEffect, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Tab, Tabs, Typography } from '@mui/material';
import TMDB_api_service from "../../network/tmdb_network_service/TMDB_api_callback";
import Papa from 'papaparse';
import UnmatchedMoviesDialog from "../../components/DataPipeline/UnmatchedMoviesDialog";
import PosterGridDialog from "../../components/DataPipeline/PosterGridDialog";
import JsonViewerDialog from "../../components/DataPipeline/JsonViewerDialog";
import OPEN_AI_api_service from "../../network/open_ai/OPEN_AI_api_callback";
import OpenAIQuestionDialog from "../../components/DataPipeline/OpenAIQuestionDialog";
import OMDB_api_service from "../../network/omdb_network_service/OMDB_api_callback";
import Spotify_api_service from "../../network/spotify_network_service/Spotify_api_callback";
import { SpotifyContentType } from "../../network/spotify_network_service/Spotify_constant";
import Jio_Saavan_api_service from "../../network/jio_saavn_network_service/Jio_Saavan_api_callback"
import { toast } from "react-toastify";

const csv_data = [
    { Title: "Lagaan", Year: "2001", Type: "Movie" },
    { Title: "Dil Chahta Hai", Year: "2001", Type: "Movie" },
    { Title: "Rang De Basanti", Year: "2006", Type: "Movie" },
    { Title: "3 Idiots", Year: "2009", Type: "Movie" },
    { Title: "PK", Year: "2016", Type: "Movie" },
    { Title: "PKK", Year: "2014", Type: "Movie" },
    { Title: "Bajrangi Bhaijaan", Year: "2015", Type: "Movie" },
    { Title: "Sacred Games", Year: "2018", Type: "Series" },
    { Title: "Mirzapura", Year: "2018", Type: "Series" },
    { Title: "Panchayat", Year: "2020", Type: "Series" },
];

const csv_data_music = [
    { "Artist": "Aastha Gill", "Albums": [], "Years": [] },
    { "Artist": "Alka Yagnik", "Albums": [], "Years": [] },
    { "Artist": "Amit Trivedi", "Albums": [], "Years": [] },
    { "Artist": "Ankit Tiwari", "Albums": [], "Years": [] },
    { "Artist": "Anu Malik", "Albums": [], "Years": [] },
    { "Artist": "A.R. Rahman", "Albums": [], "Years": [] },
    { "Artist": "Arijit Singh", "Albums": ["Stree 2", "Ashiqui 2"], "Years": [2012, 2013, 2014, 2015, 2016] },
    { "Artist": "Armaan Malik", "Albums": [], "Years": [] },
    { "Artist": "Asha Bhosle", "Albums": [], "Years": [] },
    { "Artist": "Atif aslam", "Albums": [], "Years": [] },
    { "Artist": "Badshah", "Albums": [], "Years": [] },
    { "Artist": "Darshan Raval", "Albums": [], "Years": [] },
    { "Artist": "Dhvani Bhanushali", "Albums": [], "Years": [] },
    { "Artist": "Dino James", "Albums": [], "Years": [] },
    { "Artist": "Divine", "Albums": [], "Years": [] },
    { "Artist": "Emiway bantai", "Albums": [], "Years": [] },
    { "Artist": "Farhan Akhtar", "Albums": [], "Years": [] },
    { "Artist": "Guru Randhawa", "Albums": [], "Years": [] },
    { "Artist": "Himesh Reshammiya", "Albums": [], "Years": [] },
    { "Artist": "Javed Ali", "Albums": [], "Years": [] },
    { "Artist": "Kishore Kumar", "Albums": [], "Years": [] },
    { "Artist": "KK", "Albums": [], "Years": [] },
    { "Artist": "Kumar Sanu", "Albums": [], "Years": [] },
    { "Artist": "Lata Mangeshwar", "Albums": [], "Years": [] },
    { "Artist": "Mahendra Kapoor", "Albums": [], "Years": [] },
    { "Artist": "Mika Singh", "Albums": [], "Years": [] },
    { "Artist": "Mohammad Rafi", "Albums": [], "Years": [] },
    { "Artist": "Mohit Chauhan", "Albums": [], "Years": [] },
    { "Artist": "Monali Thakur", "Albums": [], "Years": [] },
    { "Artist": "Neha Kakkar", "Albums": [], "Years": [] },
    { "Artist": "Pritam", "Albums": [], "Years": [] },
    { "Artist": "Raftaar", "Albums": [], "Years": [] },
    { "Artist": "Sachet Tandon", "Albums": [], "Years": [] },
    { "Artist": "Sanam", "Albums": [], "Years": [] },
    { "Artist": "Shaan", "Albums": [], "Years": [] },
    { "Artist": "Shankar Mahadevan", "Albums": [], "Years": [] },
    { "Artist": "Shekhar Ravjiani", "Albums": [], "Years": [] },
    { "Artist": "Shreya Ghoshal", "Albums": [], "Years": [] },
    { "Artist": "Sonu Nigam", "Albums": [], "Years": [] },
    { "Artist": "Sukhwinder Singh", "Albums": [], "Years": [] },
    { "Artist": "Sunidhi Chauhan", "Albums": [], "Years": [] },
    { "Artist": "Tulsi Kumar", "Albums": [], "Years": [] },
    { "Artist": "Udit Narayan", "Albums": [], "Years": [] },
    { "Artist": "Usha Uthup", "Albums": [], "Years": [] },
    { "Artist": "Vishal Dadlani", "Albums": [], "Years": [] }
]

const question_temp_resp = [{ "id": "1", "question": "What is the original title of the movie '3 Idiots' in Hindi?", "options": ["1. 3 Idiots", "2. तीन बेवकूफ", "3. 3 बुद्धिमान", "4. तीन विद्वान"], "correctAnswer": "2. तीन बेवकूफ", "correctAnswerIndex": 1, "difficulty": "medium" }, { "id": "2", "question": "In which year was '3 Idiots' released?", "options": ["A. 2007", "B. 2008", "C. 2009", "D. 2010"], "correctAnswer": "C. 2009", "correctAnswerIndex": 2, "difficulty": "easy" }, { "id": "3", "question": "Which two genres describe the movie '3 Idiots'?", "options": ["A. Horror, Thriller", "B. Drama, Comedy", "C. Action, Romance", "D. Sci-Fi, Fantasy"], "correctAnswer": "B. Drama, Comedy", "correctAnswerIndex": 1, "difficulty": "easy" }, { "id": "4", "question": "How many minutes is the runtime of '3 Idiots'?", "options": ["A. 150 minutes", "B. 171 minutes", "C. 180 minutes", "D. 120 minutes"], "correctAnswer": "B. 171 minutes", "correctAnswerIndex": 1, "difficulty": "medium" }, { "id": "5", "question": "What is the tagline of '3 Idiots'?", "options": ["A. Smile Always!", "B. Life is Beautiful", "C. Aal Izz Well!", "D. The Journey Begins"], "correctAnswer": "C. Aal Izz Well!", "correctAnswerIndex": 2, "difficulty": "medium" }, { "id": "6", "question": "Based on the visual qualities of the main poster for '3 Idiots', what is its primary color?", "options": ["A. Blue", "B. Red", "C. Green", "D. Yellow"], "correctAnswer": "D. Yellow", "correctAnswerIndex": 3, "difficulty": "hard" }, { "id": "7", "question": "In which language is '3 Idiots' originally made?", "options": ["A. English", "B. Hindi", "C. Tamil", "D. Bengali"], "correctAnswer": "B. Hindi", "correctAnswerIndex": 1, "difficulty": "easy" }, { "id": "8", "question": "What theme can be identified from the backdrop of '3 Idiots', which depicts a college environment?", "options": ["A. Urban Life", "B. Nature", "C. War", "D. Historical"], "correctAnswer": "A. Urban Life", "correctAnswerIndex": 0, "difficulty": "medium" }, { "id": "9", "question": "How many production companies were involved in making '3 Idiots'?", "options": ["A. 1", "B. 2", "C. 3", "D. 4"], "correctAnswer": "B. 2", "correctAnswerIndex": 1, "difficulty": "easy" }, { "id": "10", "question": "Which of the following logos represents a production company involved in '3 Idiots'?", "options": ["A. /yzvunYIcSuClORJR9VWzpUvlbIW.png", "B. /dQrs6IAfRt8pkf2u3Bgfgui87Jf.png", "C. /yf3HhYiDpW8pvK7u6h3NRuyBHQb.png", "D. /xFNJ82IAAyyarlkp8kxbE5Gsy6f.png"], "correctAnswer": "A. /yzvunYIcSuClORJR9VWzpUvlbIW.png", "correctAnswerIndex": 0, "difficulty": "hard" }];

function DataPipeline({ }) {

    const location = useLocation();
    const [matchedMoviesData, setMatchedMoviesData] = useState([]);
    const [unMatchedMoviesData, setUnMatchedMoviesData] = useState([]);
    const [title, setTitle] = useState(location?.state?.data?.childLabel);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);
    const [openViewUnMachedDialog, setOpenViewUnMachedDialog] = useState(false);
    const [openViewPostersDialog, setOpenViewPostersDialog] = useState(false);
    const [currentItemPosters, setCurrentItemPosters] = useState(null);
    const [currentItem, setCurrentItem] = useState(null);
    const [openViewJSONDialog, setOpenViewJSONDialog] = useState(false);
    const [openAIQuestionDialog, setOpenAIQuestionDialog] = useState(false);
    const [openAIGeneratedQuestion, setOpenAIGeneratedQuestion] = useState(question_temp_resp);
    const [matchedMusicData, setMatchedMusicData] = useState([]);
    const [matchedMusicDataV2, setMatchedMusicDataV2] = useState([]);
    const [unMatchedMusicData, setUnMatchedMusicData] = useState([]);
    const [unMatchedMusicDataV2, setUnMatchedMusicDataV2] = useState([]);
    const [spotifyTabIndex, setSpotifyTabIndex] = useState(0);
    const [resultsJioSaavan, setResultsJioSaavan] = useState([])
    const [errorResultJioSaavan, setErrorResultJioSaavan] = useState([])

    useEffect(() => {
        if (title !== location?.state?.data?.childLabel) {
            setMatchedMoviesData([]);
            setUnMatchedMoviesData([]);
            setOpenViewJSONDialog(false);
            setOpenViewPostersDialog(false);
            setOpenViewUnMachedDialog(false);
            setCurrentItem(null);
            setCurrentItemPosters(null);
            setResultsJioSaavan([]);
            setErrorResultJioSaavan([]);
            setMatchedMusicDataV2([]);
            setUnMatchedMusicDataV2([]);
            setMatchedMusicData([]);
            setUnMatchedMusicData([]);
            setSpotifyTabIndex(0);
        }
        setTitle(location?.state?.data?.childLabel);

        if (openAIGeneratedQuestion) {
            console.log("openAIGeneratedQuestion : ", openAIGeneratedQuestion);
        }

        if (title?.toUpperCase() === 'SPOTIFY' && location?.state?.data?.childLabel?.toUpperCase() === 'SPOTIFY') {
            console.log("title : ", title?.toUpperCase())
            //getSpotifyNewRelease();
            //createCSVForMusic();
        }
        if (title?.toUpperCase() === 'JIO SAAVAN' && location?.state?.data?.childLabel?.toUpperCase() === 'JIO SAAVAN') {
            console.log("title : ", title?.toUpperCase())
            //getJioSaavan();
        }
        //searchMovie("tt0073707");
        //searchAllMoviesByTitleAndYear("sholay","1975");
        //console.log("currentItemPosters : ",currentItemPosters)
    }, [location, title, matchedMoviesData, currentItemPosters, openAIGeneratedQuestion, matchedMusicData, unMatchedMusicData, matchedMusicDataV2, unMatchedMusicDataV2, resultsJioSaavan, errorResultJioSaavan]);

    const getJioSaavan = async (list) => {
        setLoading(true);
        const inputData = [
            // { Artist: "A. R. Rehman", Albums: "", Years: "2012,2013,2014,2015,2016" },
            // { Artist: "Arijit Singh", Albums: "Stree 2,Aashiqui 2", Years: "2018,2019,2024" }
            { Artist: "Arijit Singh", Albums: "", Years: "" }
        ]
        const errorResultJioSaavan = [];
        try {
            const resultsJioSaavan = [];

            for (const item of list) {
                const artistName = item.Artist;
                const albumFilter = item.Albums ? item.Albums.split(",").map(a => a.trim().toLowerCase()) : [];
                const yearFilter = item.Years ? item.Years.split(",").map(y => y.trim()) : [];

                // 1. Search Artist by Name
                const artistResponse = await Jio_Saavan_api_service.searchEverythingByName(artistName);

                if (!artistResponse.success || !artistResponse.artist?.id) {
                    console.warn(`❌ Artist not found: ${artistName}`);
                    errorResultJioSaavan.push({
                        CSV: item,
                        artist: item?.Artist,
                        artistId: "",
                        artistDetails: null,
                        totalSongs: 0,
                        matchedTotalSongs: 0,
                        allSongs: [],
                        matchedSongs: [],
                        error: {
                            artist: item?.Artist,
                            msg: "Artist not found",
                        }
                    });
                    continue;
                }

                const artistId = artistResponse.artist.id;

                const artistDetail = await Jio_Saavan_api_service.artistDetail(artistId);
                if (!artistDetail.success) {
                    console.warn(`❌ Artist Detail not found: ${artistName}`);
                    errorResultJioSaavan.push({
                        CSV: item,
                        artist: artistName,
                        artistId,
                        artistDetails: null,
                        totalSongs: 0,
                        matchedTotalSongs: 0,
                        allSongs: [],
                        matchedSongs: [],
                        error: {
                            artist: item?.Artist,
                            msg: "Artist detail not found",
                        }
                    });
                    continue;
                }

                // 2. Get All Songs by Artist ID
                const trackResponse = await Jio_Saavan_api_service.searchArtistSongsByArtistIDAndPage(artistId);

                if (!trackResponse.success || !trackResponse.songs?.length) {
                    console.warn(`⚠️ No songs found for artist: ${artistName}`);
                    errorResultJioSaavan.push({
                        CSV: item,
                        artist: artistName,
                        artistId,
                        artistDetails: artistDetail?.data,
                        totalSongs: 0,
                        matchedTotalSongs: 0,
                        allSongs: [],
                        matchedSongs: [],
                        error: {
                            artist: item?.Artist,
                            msg: "No songs found",
                        }
                    });
                    continue;
                }

                // 3. Filter Songs by Year and Album
                const filteredSongs = trackResponse.songs.filter(song => {
                    const songYear = song.year;
                    const songAlbum = song.album?.name?.toLowerCase();

                    //console.log("yearFilter : ",yearFilter)
                    //console.log("year : "+songYear+" : ",yearFilter?.includes(songYear))
                    const matchYear = yearFilter?.length ? yearFilter?.includes(songYear) : false;
                    const matchAlbum = albumFilter?.length ? albumFilter?.includes(songAlbum) : false;

                    if (matchYear || matchAlbum) {
                        return true;
                    }
                    else {
                        if (yearFilter?.length > 0 && albumFilter?.length > 0) {
                            return false;
                        }
                        else {
                            return false;
                        }
                    }
                });

                resultsJioSaavan.push({
                    CSV: item,
                    artist: artistName,
                    artistId,
                    artistDetails: artistDetail?.data,
                    totalSongs: trackResponse.songs.length,
                    matchedTotalSongs: filteredSongs.length,
                    allSongs: trackResponse.songs,
                    matchedSongs: filteredSongs
                });
            }

            return { resultsJioSaavan, errorResultJioSaavan };
        } catch (error) {
            errorResultJioSaavan.push({
                CSV: list,
                artist: "",
                artistId: "",
                artistDetails: null,
                totalSongs: 0,
                matchedTotalSongs: 0,
                allSongs: [],
                matchedSongs: [],
                error: {
                    artist: "",
                    msg: `API error : ${error}`,
                }
            });
            console.error('Failed to fetch Jio Saavan : ', error);
        } finally {
            setLoading(false);
        }
    }

    const getMoviesList = async (page) => {
        setLoading(true);
        try {
            const response = await TMDB_api_service.discoverAllMoviesList(page = page > 0 ? page : 1);
            console.log('TMDB searchByIMDBID response:', response);
        } catch (error) {
            console.error('Failed to fetch movie by IMDB ID:', error);
        } finally {
            setLoading(false);
        }
    }

    const getQuestionsFromOpenAI = async (movie) => {
        setLoading(true);
        try {
            const response = await OPEN_AI_api_service.getQuestionsFromMovieMetadata(movie);
            console.log('OpenAI response:', response);
            setLoading(false);
            const content = response.data.choices?.[0]?.message?.content
            if(content)
            {
                toast.success("OpenAI generated questions in " + parseInt(response?.duration/1000) + " seconds");
                setOpenAIGeneratedQuestion(JSON.parse(content));
            }
        } catch (error) {
            console.error('Failed to fetch questions from Open AI:', error);
        } finally {

        }
    }

    const getQuestionsFromMoviesListViaOpenAI = async (movieList) => {
        generateAllTrivia(movieList).then(result => console.log("All Trivia:", result)).catch(err => console.error(err));
    }

    const getMovieDetailsFromOMDB = async (movieList) => {
        setLoading(true);

        const moviePromises = movieList.map((movie) => {
            const title = movie.Title?.trim();
            const year = movie.Year?.trim();
            const type = movie.Type?.trim();

            return OMDB_api_service
                .detailByTitleOrIDWithYearAndType(title, year, type)
                .then((res) => ({
                    status: "fulfilled",
                    movie,
                    result: res,
                }))
                .catch((err) => ({
                    status: "rejected",
                    movie,
                    error: err,
                }));
        });
        const settledResults = await Promise.allSettled(moviePromises);
        const matchedMovies = [];
        const errorMovies = [];

        //console.log("settledResults => ", settledResults);
        for (const settled of settledResults) {
            if (settled.status === "fulfilled") {
                const { status, movie, result, requestParams } = settled.value;

                const isOmdbError = result?.Response === "False";
                const isEmptyResults = !result || result?.length === 0;

                if (!isOmdbError && !result?.error && !isEmptyResults) {
                    matchedMovies.push({ ...movie, omdbResult: result });
                } else {
                    errorMovies.push({
                        ...movie,
                        failedParams: { Title: movie.Title, Year: movie.Year, Type: movie.Type },
                        omdbError: result?.Error || "Unknown OMDB Error",
                    });
                }

                // if (status === "fulfilled" && result && !result.error && !isEmptyResults) {
                //     matchedMovies.push({ ...movie, omdbResult: result });
                //     //console.log("matchedMovies.push => ", matchedMovies);
                // } else {
                //     errorMovies.push({ ...movie, failedParams: requestParams });
                // }

            } else if (settled.status === "rejected") {
                const { movie, requestParams } = settled.reason || {};
                errorMovies.push({
                    ...(movie || { Title: "Unknown" }),
                    failedParams: requestParams || {},
                });
            }
        }


        //console.log("matchedMovies => ", matchedMovies);
        setLoading(false);
        return { matchedMovies, errorMovies };
    }

    const generateAllTrivia = async (movies) => {
        const triviaMap = {};
        for (const meta of movies) {
            const questions = await OPEN_AI_api_service.getQuestionsFromMovieMetadata(meta);
            triviaMap[meta.title] = questions;
        }
        return triviaMap;
    }

    const searchMovieById = async (imdbId = "tt0073707") => {
        setLoading(true);
        try {
            const response = await TMDB_api_service.searchByIMDBID(imdbId);
            console.log('TMDB searchByIMDBID response:', response);
        } catch (error) {
            console.error('Failed to fetch movie by IMDB ID:', error);
        } finally {
            setLoading(false);
        }
    }

    const searchAllMoviesByTitleAndYear = async (movieList) => {
        setLoading(true);

        const moviePromises = movieList.map((movie) => {
            const title = movie.Title?.trim();
            const year = movie.Year?.trim();
            const type = movie.Type?.trim();

            return TMDB_api_service
                .searchByMovieTitle(title, year, type)
                .then((res) => ({
                    status: "fulfilled",
                    movie,
                    result: res,
                }))
                .catch((err) => ({
                    status: "rejected",
                    movie,
                    error: err,
                }));
        });

        const settledResults = await Promise.allSettled(moviePromises);

        const matchedMovies = [];
        const errorMovies = [];

        for (const settled of settledResults) {
            if (settled.status === "fulfilled") {
                const { status, movie, result, requestParams } = settled.value;

                const isEmptyResults = !result?.results || result.results.length === 0;

                if (status === "fulfilled" && result && !result.error && !isEmptyResults) {
                    matchedMovies.push({ ...movie, tmdbResult: result });
                } else {
                    errorMovies.push({ ...movie, failedParams: requestParams });
                }

            } else if (settled.status === "rejected") {
                const { movie, requestParams } = settled.reason || {};
                errorMovies.push({
                    ...(movie || { Title: "Unknown" }),
                    failedParams: requestParams || {},
                });
            }
        }

        // 3. Create detail fetch promises (based on source)
        const detailPromises = matchedMovies.map((item) => {
            if (item?.tmdbResult?.source === "tv") {
                return TMDB_api_service
                    .tvShowDetails(item?.tmdbResult?.results?.[0]?.id)
                    .then((details) => ({ ...item, tmdbDetail: details }))
                    .catch(() => ({ ...item, detailError: true }));
            } else if (item?.tmdbResult?.source === "movie") {
                return TMDB_api_service
                    .movieDetails(item?.tmdbResult?.results?.[0]?.id)
                    .then((details) => ({ ...item, tmdbDetail: details }))
                    .catch(() => ({ ...item, detailError: true }));
            } else {
                return Promise.resolve({ ...item, detailError: true });
            }
        });

        // 4. Await all detail results
        const detailedResults = await Promise.all(detailPromises);

        const imagesPromises = detailedResults.map((item) => {
            const source = item?.tmdbResult?.source;
            const movieId = item?.tmdbDetail?.id;
            const imdb_id = item?.tmdbDetail?.imdb_id;
            const title = item?.tmdbDetail?.title;
            const original_title = item?.tmdbDetail?.original_title;

            const fetchImages = source === "tv"
                ? TMDB_api_service.tvShowsImages(movieId)
                : TMDB_api_service.movieImages(movieId);


            return fetchImages
                .then((images) => ({
                    ...item,
                    tmdbDetail: {
                        ...item.tmdbDetail, // retain existing detail
                        images: images || {} // inject images
                    }
                }))
                .catch(() => ({
                    ...item,
                    tmdbDetail: {
                        ...item.tmdbDetail,
                        images: {} // still attach empty images if failed
                    },
                    detailError: true
                }));
        });

        const imagesWithResults = await Promise.all(imagesPromises);
        //console.log("imagesPromises : ", imagesWithResults)
        setLoading(false);
        //console.log("✅ Matched Movies:", matchedMovies);
        //console.log("✅ Matched Movies Detail:", imagesWithResults);
        //console.log("❌ Not Found/Error Movies:", errorMovies);

        return { imagesWithResults, errorMovies };
    };

    const createCSVForMusic = () => {
        if (!csv_data_music || !Array.isArray(csv_data_music)) return;

        const formatted = csv_data_music?.map((item) => {
            console.log("item : ", item)
            return {
                Artist: item?.Artist,
                Albums: (item?.Albums || []).join(", "),
                Years: (item?.Years || []).join(", "),
            }
        }
        );

        const csv = Papa.unparse(formatted);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.href = url;
        link.setAttribute("download", "music_artists.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDownload = () => {
        const modified = csv_data?.map((item) => {
            if (item.Title.includes(",") && item.Title.split(",").length === 3) {
                const [newTitle, newType, newYear] = item.Title.split(",");
                return {
                    Title: newTitle,
                    Type: newYear, // swapped
                    Year: newType, // swapped
                };
            }
            return item;
        });

        const csv = Papa.unparse(modified);

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.href = url;
        link.setAttribute("download", "modified_data.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const renederMatchedMovies = async (results) => {
        if (title?.toUpperCase() === 'TMDB') {
            const { imagesWithResults, errorMovies } = await searchAllMoviesByTitleAndYear(results?.data);
            if (imagesWithResults?.length > 0 && Array.isArray(imagesWithResults)) {
                setMatchedMoviesData(imagesWithResults);
            }
            if (errorMovies?.length > 0 && Array.isArray(errorMovies)) {
                setUnMatchedMoviesData(errorMovies);
            }
            //console.log("detailedResults : ",detailedResults);
        }
        else if (title?.toUpperCase() === 'OMDB') {
            const { matchedMovies, errorMovies } = await getMovieDetailsFromOMDB(results?.data);
            console.log("result : ", matchedMovies);
            if (matchedMovies?.length > 0 && Array.isArray(matchedMovies)) {
                setMatchedMoviesData(matchedMovies);
            }
            if (errorMovies?.length > 0 && Array.isArray(errorMovies)) {
                setUnMatchedMoviesData(errorMovies);
            }
        }
        else if (title?.toUpperCase() === 'SPOTIFY') {
            //await getSpotifyArtistDetailWithAlbumsAndTracks(results?.data);
            const { newSpotifyV2Data, errorArtist } = await getSpotifyArtistDetailWithTopTracks(results?.data);
            //const { matchedArtistsWithFilteredAlbumsWithTracksV2, errorArtistsWithFilteredAlbumsWithTracksV2 } = await getSpotifyArtistDetailWithAlbumsAndTracks(results?.data);
            //const { matchedArtistsWithFilteredAlbumsV2, errorArtistsWithFilteredAlbumsV2 } = await getSpotifyArtistDetailWithAlbumsAndTracks(results?.data);
            setMatchedMusicData(newSpotifyV2Data);
            //setMatchedMusicDataV2(matchedArtistsWithFilteredAlbumsWithTracksV2);
            //setMatchedMusicDataV2(matchedArtistsWithFilteredAlbumsV2);
            setUnMatchedMusicData(errorArtist);
            //setUnMatchedMusicDataV2(errorArtistsWithFilteredAlbumsWithTracksV2);
            //setUnMatchedMusicDataV2(errorArtistsWithFilteredAlbumsV2);


            //matchedArtistsWithTopTracks && SpotifyV1View()
        }
        else if (title?.toUpperCase() === 'JIO SAAVAN') {
            const { resultsJioSaavan, errorResultJioSaavan } = await getJioSaavan(results?.data);
            setResultsJioSaavan(resultsJioSaavan);
            setErrorResultJioSaavan(errorResultJioSaavan);
            //console.log("JIO SAAVAN resultsJioSaavan => ",resultsJioSaavan)
            //console.log("JIO SAAVAN errorResultJioSaavan => ",errorResultJioSaavan)
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                console.log('Parsed CSV Data:', results.data);
                // You can store in state or process it as needed
                renederMatchedMovies(results);
                e.target.value = null;
            },
        });
    };

    const handleOnCSVUploadClick = () => {
        fileInputRef.current.click(); // Trigger file input
        console.log('Create button clicked!!');
    };

    const handleDownloadAsJson = (obj) => {
        const jsonString = JSON.stringify(obj, null, 2); // pretty-print
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        const fileName = `movies-data-${timestamp}.json`;

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();

        URL.revokeObjectURL(url); // clean up
    };

    function removeKeyDeep(obj, keysToRemove) {
        if (Array.isArray(obj)) {
            return obj.map(item => removeKeyDeep(item, keysToRemove));
        } else if (typeof obj === 'object' && obj !== null) {
            const newObj = {};
            for (const [key, value] of Object.entries(obj)) {
                if (!keysToRemove.includes(key)) {
                    newObj[key] = removeKeyDeep(value, keysToRemove);
                }
            }
            return newObj;
        }
        return obj;
    }

    const getArtistByName = (res, artist_name) => {
        //console.log("res : ",res)
        if (!res?.artists?.items || !Array.isArray(res.artists.items)) return null;

        const foundArtist = res.artists.items.find(
            (artist) => {
                //console.log("artist : ",artist.name)
                return artist.name.toLowerCase() === artist_name.toLowerCase()
            }
        );

        return foundArtist || null;
    };

    const getAllArtistAlbums = async (artistId) => {
        const limit = 50; // Use the max allowed by Spotify
        let offset = 0;
        let allAlbums = [];
        let total = null;

        try {
            // First request
            const firstRes = await Spotify_api_service.spotifyGetArtistAlbums(artistId, limit, offset);
            total = firstRes?.total || 0;
            allAlbums = firstRes?.items || [];

            // Calculate how many more pages we need
            const totalPages = Math.ceil(total / limit);

            // Fetch remaining pages in parallel
            const pagePromises = [];
            for (let i = 1; i < totalPages; i++) {
                const pageOffset = i * limit;
                pagePromises.push(
                    Spotify_api_service.spotifyGetArtistAlbums(artistId, limit, pageOffset)
                );
            }

            const pageResults = await Promise.all(pagePromises);
            pageResults.forEach((res) => {
                allAlbums = allAlbums.concat(res?.items || []);
            });

            return allAlbums;
        } catch (err) {
            console.error("Error fetching albums for artist ID:", artistId, err);
            throw err;
        }
    };

    const getAlbumTracks = async (album_Id) => {
        try {
            const albumTracksPromise = await Spotify_api_service.spotifyGetAlbumTracks(album_Id);

            const albumTracksResults = await Promise.all(albumTracksPromise);
            console.log("albumTracksResults : ", albumTracksResults);
        } catch (err) {
            console.error("Error fetching albums for artist ID:", album_Id, err);
            throw err;
        }
    };

    const getSpotifyArtistDetailWithAlbumsAndTracks = async (list) => {
        setLoading(true);
        const artistPromise = list.map((item) => {
            const Artist = item.Artist?.trim();
            const CSV_Albums = item.Albums?.trim();
            const CSV_Years = item.Years?.trim();

            return Spotify_api_service
                .spotifySearchSongByTitle(Artist, SpotifyContentType.ARTIST)
                .then((res) => {
                    const ArtistDetail = getArtistByName(res, Artist);
                    if (!ArtistDetail) {
                        // Reject manually if no match found
                        throw new Error(`Artist "${Artist}" not found`);
                    }
                    return {
                        status: "fulfilled",
                        item,
                        ArtistDetail,
                    };
                })
                .catch((err) => ({
                    status: "rejected",
                    item,
                    error: err,
                }));
        });

        const settledResults = await Promise.allSettled(artistPromise);

        const matchedArtist = [];
        const errorArtist = [];

        for (const settled of settledResults) {
            if (settled.status === "fulfilled") {
                const { status, item, ArtistDetail, requestParams, error } = settled.value;

                //const isEmptyResults = !result?.results || result.results.length === 0;

                if (status === "fulfilled" && ArtistDetail && !error) {
                    matchedArtist.push({ item, ArtistDetail });
                } else {
                    errorArtist.push({ item });
                }

            } else if (settled.status === "rejected") {
                const { item, requestParams } = settled.reason || {};
                errorArtist.push({ item });
            }
        }

        console.log("✅ Matched Artists:", matchedArtist);
        console.log("❌ Not Found/Error Artists:", errorArtist);

        const albumsPromise = matchedArtist?.map((item) => {
            //console.log("item : ",item)
            const artist_id = item?.ArtistDetail?.id;
            const artist_name = item?.ArtistDetail?.name;

            return getAllArtistAlbums(artist_id)
                .then((allAlbums) => ({
                    status: "fulfilled",
                    CSV: { ...item?.item },
                    ArtistDetail: { ...item?.ArtistDetail },
                    Albums: allAlbums,
                }))
                .catch((err) => ({
                    status: "rejected",
                    item,
                    error: err,
                }));
        });

        const albumsResult = await Promise.allSettled(albumsPromise);

        const matchedArtistsWithFilteredAlbumsV2 = [];
        const errorArtistsWithFilteredAlbumsV2 = [];

        for (const settled of albumsResult) {
            if (settled.status === "fulfilled") {
                const { status, CSV, ArtistDetail, Albums, requestParams, error } = settled.value;

                const originalAlbums = CSV?.Albums || "";
                const parsedAlbums = originalAlbums
                    .split(",")
                    .map((album) => album.trim())
                    .filter((album) => album.length > 0);

                const originalYears = CSV?.Years || "";
                const parsedYears = originalYears
                    .split(",")
                    .map((years) => years.trim())
                    .filter((years) => years.length > 0);

                const isEmptyResults = !Albums || Albums.length === 0;

                //console.log("settled.value : ",settled.value)
                console.log("settled.value parsedAlbums : ", parsedYears)

                if (status === "fulfilled" && Albums && !error) {
                    var filtered_albums = [];
                    for (const album of Albums) {
                        const album_name = album?.name;
                        const album_id = album?.id;
                        const album_release_date = album?.release_date?.trim();;
                        const album_release_year = new Date(album_release_date).getFullYear()?.toString()?.trim();
                        const foundYearsAlbum = parsedYears?.find(
                            (csv_album) => {
                                //console.log("Albums : ", album_name +" : "+ album_release_date +" : "+album_release_year)
                                //console.log("csv_album : ",csv_album +" - "+album_release_year)
                                return (csv_album?.trim() === album_release_year)
                            }
                        );

                        const foundAlbum = parsedAlbums?.find(
                            (csv_album) => {
                                //console.log("Albums : ", album_name +" : "+ album_release_date +" : "+album_release_year)
                                return (csv_album?.toLowerCase() === album_name?.toLowerCase() || album_name?.toLowerCase()?.includes(csv_album?.toLowerCase()))
                            }
                        );
                        if ((foundAlbum || foundYearsAlbum) && (parsedYears || parsedAlbums)) {
                            //const albumTracksResponse = await Spotify_api_service.spotifyGetAlbumTracks(album_id);
                            foundAlbum && filtered_albums.push({ filteredBy: "Album", ...album });
                            foundYearsAlbum && filtered_albums.push({ filteredBy: "Year", ...album });
                        }
                    }
                    if (filtered_albums && filtered_albums?.length > 0) {
                        matchedArtistsWithFilteredAlbumsV2.push({ CSV, ArtistDetail, Albums: filtered_albums });
                    }
                    else {
                        matchedArtistsWithFilteredAlbumsV2.push({ CSV, ArtistDetail, Albums });
                    }
                } else {
                    errorArtistsWithFilteredAlbumsV2.push({ CSV });
                }

            } else if (settled.status === "rejected") {
                const { item, requestParams } = settled.reason || {};
                errorArtistsWithFilteredAlbumsV2.push({ item });
            }
        }


        console.log("✅ Matched Artists Albums:", matchedArtistsWithFilteredAlbumsV2);
        console.log("❌ Not Found/Error Artists Albums:", errorArtistsWithFilteredAlbumsV2);

        // const matchedArtistsWithFilteredAlbumsWithTracksV2 = [];
        // const errorArtistsWithFilteredAlbumsWithTracksV2 = [];

        // for (const artist of matchedArtistsWithFilteredAlbumsV2) {
        //     //console.log("artist1 => ",artist)
        //     if (!artist?.Albums || artist?.Albums?.length===0) return;
        //     var artistAllTracks = [];
        //     //console.log("artist2 => ",artist?.Albums)

        //     for (var i=0 ; i<=artist?.Albums?.length ; i++)
        //     {
        //         const album = artist?.Albums?.[i];
        //         //console.log("album1 => ",album)
        //         if(album)
        //         {
        //          const response = await getAlbumAllTracks(album?.id);
        //          console.log("artistSpecificAlbumTracks : ",response)    
        //          matchedArtistsWithFilteredAlbumsWithTracksV2.push({CSV:artist?.CSV,ArtistDetail:artist?.ArtistDetail,Album:album,Tracks:response})
        //         }
        //     }
        // }

        // console.log("✅ Matched Artists Albums Tracks:", matchedArtistsWithFilteredAlbumsWithTracksV2);
        // console.log("❌ Not Found/Error Artists Albums Tracks:", errorArtistsWithFilteredAlbumsWithTracksV2);

        setLoading(false);
        //return {matchedArtistsWithFilteredAlbumsWithTracksV2,errorArtistsWithFilteredAlbumsWithTracksV2}
        return { matchedArtistsWithFilteredAlbumsV2, errorArtistsWithFilteredAlbumsV2 }
    }

    const getAlbumAllTracks = async (albumId) => {
        const response = await Spotify_api_service.spotifyGetAlbumTracks(albumId)
        //console.log("artistSpecificAlbumTracks : ",response)        
        return response?.items;
    }

    const getSpotifyArtistDetailWithTopTracks = async (list) => {
        setLoading(true);

        const artistPromise = list.map((item) => {
            const Artist = item.Artist?.trim();
            const Albums = item.Albums?.trim();
            const Years = item.Years?.trim();

            return Spotify_api_service
                .spotifySearchSongByTitle(Artist, SpotifyContentType.ARTIST)
                .then((res) => {
                    const ArtistDetail = getArtistByName(res, Artist);
                    if (!ArtistDetail) {
                        // Reject manually if no match found
                        throw new Error(`Artist "${Artist}" not found`);
                    }
                    return {
                        status: "fulfilled",
                        item,
                        ArtistDetail,
                    };
                })
                .catch((err) => ({
                    status: "rejected",
                    item,
                    error: err,
                }));
        });

        const settledResults = await Promise.allSettled(artistPromise);

        const matchedArtist = [];
        const errorArtist = [];

        for (const settled of settledResults) {
            if (settled.status === "fulfilled") {
                const { status, item, ArtistDetail, requestParams, error } = settled.value;

                //const isEmptyResults = !result?.results || result.results.length === 0;

                if (status === "fulfilled" && ArtistDetail && !error) {
                    matchedArtist.push({ item, ArtistDetail });
                } else {
                    errorArtist.push({ item });
                }

            } else if (settled.status === "rejected") {
                const { item, requestParams } = settled.reason || {};
                errorArtist.push({ item });
            }
        }

        console.log("✅ Matched Artists:", matchedArtist);
        console.log("❌ Not Found/Error Artists:", errorArtist);

        const topTracksPromise = matchedArtist?.map((item) => {
            //console.log("item : ",item)
            const artist_id = item?.ArtistDetail?.id;
            const artist_name = item?.ArtistDetail?.name;

            return Spotify_api_service
                .spotifyGetArtistTopTracks(artist_id)
                .then((res) => {
                    //console.log("res => : ", res?.tracks)
                    return {
                        status: "fulfilled",
                        CSV: { ...item?.item },
                        ArtistDetail: { ...item?.ArtistDetail },
                        TopTracks: res?.tracks?.length > 0 ? [...res?.tracks] : []
                    }
                })
                .catch((err) => ({
                    status: "rejected",
                    item,
                    error: err,
                }));
        });

        const topTracksResult = await Promise.allSettled(topTracksPromise);

        const matchedArtistsWithTopTracks = [];
        const errorArtistsWithTopTracks = [];

        for (const settled of topTracksResult) {
            if (settled.status === "fulfilled") {
                const { status, CSV, ArtistDetail, TopTracks, requestParams, error } = settled.value;

                //console.log("settled.value : ", settled.value)
                //console.log("settled.value TopTracks : ",status)

                const isEmptyResults = !TopTracks || TopTracks.length === 0;

                if (status === "fulfilled" && TopTracks && !error) {
                    matchedArtistsWithTopTracks.push({ CSV, ArtistDetail, TopTracks });
                } else {
                    errorArtistsWithTopTracks.push({ CSV });
                }

            } else if (settled.status === "rejected") {
                const { item, requestParams } = settled.reason || {};
                errorArtistsWithTopTracks.push({ item });
            }
        }

        const filteredMatchedArtistsWithTopTracks = removeKeyDeep(matchedArtistsWithTopTracks, ['available_markets', 'artists', 'album'])
        console.log("✅ Matched Artists Top Tracks:", filteredMatchedArtistsWithTopTracks);
        console.log("❌ Not Found/Error Artists Top Tracks:", errorArtistsWithTopTracks);

        /**
         * V2
         */
        const albumsPromise = matchedArtistsWithTopTracks?.map((item) => {
            //console.log("item : ",item)
            const artist_id = item?.ArtistDetail?.id;
            const artist_name = item?.ArtistDetail?.name;

            return getAllArtistAlbums(artist_id)
                .then((allAlbums) => ({
                    status: "fulfilled",
                    CSV: { ...item?.CSV },
                    ArtistDetail: { ...item?.ArtistDetail },
                    TopTracks: item?.TopTracks?.length > 0 ? [...item?.TopTracks] : [],
                    Albums: allAlbums,
                }))
                .catch((err) => ({
                    status: "rejected",
                    item,
                    error: err,
                }));
        });

        const albumsResult = await Promise.allSettled(albumsPromise);

        const matchedArtistsWithFilteredAlbumsV2 = [];
        const errorArtistsWithFilteredAlbumsV2 = [];

        for (const settled of albumsResult) {
            if (settled.status === "fulfilled") {
                const { status, CSV, ArtistDetail, TopTracks, Albums, requestParams, error } = settled.value;

                const originalAlbums = CSV?.Albums || "";
                const parsedAlbums = originalAlbums
                    .split(",")
                    .map((album) => album.trim())
                    .filter((album) => album.length > 0);

                const originalYears = CSV?.Years || "";
                const parsedYears = originalYears
                    .split(",")
                    .map((years) => years.trim())
                    .filter((years) => years.length > 0);

                const isEmptyResults = !Albums || Albums.length === 0;

                //console.log("settled.value : ",settled.value)
                console.log("settled.value parsedAlbums : ", parsedYears)

                if (status === "fulfilled" && Albums && !error) {
                    var filtered_albums = [];
                    for (const album of Albums) {
                        const album_name = album?.name;
                        const album_id = album?.id;
                        const album_release_date = album?.release_date?.trim();;
                        const album_release_year = new Date(album_release_date).getFullYear()?.toString()?.trim();
                        const foundYearsAlbum = parsedYears?.find(
                            (csv_album) => {
                                //console.log("Albums : ", album_name +" : "+ album_release_date +" : "+album_release_year)
                                //console.log("csv_album : ",csv_album +" - "+album_release_year)
                                return (csv_album?.trim() === album_release_year)
                            }
                        );

                        const foundAlbum = parsedAlbums?.find(
                            (csv_album) => {
                                //console.log("Albums : ", album_name +" : "+ album_release_date +" : "+album_release_year)
                                return (csv_album?.toLowerCase() === album_name?.toLowerCase() || album_name?.toLowerCase()?.includes(csv_album?.toLowerCase()))
                            }
                        );
                        if ((foundAlbum || foundYearsAlbum) && (parsedYears || parsedAlbums)) {
                            //const albumTracksResponse = await Spotify_api_service.spotifyGetAlbumTracks(album_id);
                            foundAlbum && filtered_albums.push({ filteredBy: "Album", ...album });
                            foundYearsAlbum && filtered_albums.push({ filteredBy: "Year", ...album });
                        }
                    }
                    if (filtered_albums && filtered_albums?.length > 0) {
                        matchedArtistsWithFilteredAlbumsV2.push({ CSV, ArtistDetail, TopTracks, Albums: filtered_albums });
                    }
                    else {
                        matchedArtistsWithFilteredAlbumsV2.push({ CSV, ArtistDetail, TopTracks, Albums });
                    }
                } else {
                    errorArtistsWithFilteredAlbumsV2.push({ CSV });
                }

            } else if (settled.status === "rejected") {
                const { item, requestParams } = settled.reason || {};
                errorArtistsWithFilteredAlbumsV2.push({ item });
            }
        }

        console.log("✅ Matched Artists Albums matchedArtistsWithFilteredAlbumsV2 :", matchedArtistsWithFilteredAlbumsV2);
        console.log("❌ Not Found/Error Artists Albums errorArtistsWithFilteredAlbumsV2 :", errorArtistsWithFilteredAlbumsV2);

        const newSpotifyV2Data = [];
        for (const item of matchedArtistsWithFilteredAlbumsV2) {
            
            const { CSV, ArtistDetail, TopTracks, Albums } = item;
            
            const singleArtistTracks = [];

            for (const album of Albums) {
                const album_id = album?.id;
                try {
                    const response = await Spotify_api_service.spotifyGetAlbumTracks(album_id);
                    if(response)
                    {
                        if(response?.item?.length>0)
                        {
                            singleArtistTracks.push(...response?.items);
                        }
                        else{
                            singleArtistTracks.push([]);
                        }
                    }
                } catch (err) {
                    console.error("Error fetching albums for artist ID:", album_id, err);
                    //throw err;
                }
            }
            newSpotifyV2Data.push({CSV,ArtistDetail,TopTracks,Albums,AllTracks:singleArtistTracks})
        }


        //const singleArtistAlbum = Albums.map(album => album?.id).filter(Boolean).join(',');


        console.log("✅ All Artists Album :", newSpotifyV2Data);

        setLoading(false);
        return { newSpotifyV2Data, errorArtist }
    }

    const getSpotifyNewRelease = async () => {
        try {
            //const response = await Spotify_api_service.spotifyNewRelease();
            const response = await Spotify_api_service.spotifyCategories();
            console.log("Spotify Response : ", response);
        }
        catch (error) {
            console.error('Failed to fetch new releases from Spotify : ', error);
        }
        finally {

        }
    }

    const SpotifyV1Header = () => {
        return (
            <thead>
                <tr style={{ backgroundColor: "#444", color: "white", fontWeight: "bold" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>S.No</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>ID</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Artist name</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Ranking</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Followers</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Genres</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Total Tracks</th>
                    {/* <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Total albums</th>
                                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Filters [Y/A]</th> */}
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Image</th>
                </tr>
            </thead>
        )
    }

    const SpotifyV1Body = () => {
        return (
            matchedMusicData?.map((item, index) => {
                const { ArtistDetail, TopTracks, CSV } = item;
                return (
                    <tr key={ArtistDetail.id} onClick={() => {
                        setCurrentItem(item);
                        setOpenViewJSONDialog(true);
                    }}>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{index + 1}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{ArtistDetail?.id}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{ArtistDetail?.name}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{ArtistDetail?.popularity}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{
                            ArtistDetail?.followers?.total
                        }</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{
                            (ArtistDetail.genres || []).map((genre) => genre).join(', ')}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{TopTracks?.reduce((sum, item) => sum + (item?.track_number || 0), 0)}</td>
                        {/* <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>88</td>
                                    <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>
                                        &gt; Years (12)
                                        <br />
                                        &gt; Album (18)
                                    </td> */}
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>
                            <img
                                src={ArtistDetail?.images?.[0]?.url}
                                alt="Artist"
                                style={{ width: "50px", height: "75px", objectFit: "cover" }}
                            />
                        </td>
                    </tr>
                )
            })
        )
    }

    const SpotifyV1View = () => {
        return (
            <div style={{ overflowX: "auto", padding: "16px" }}>
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        minWidth: "1000px",
                    }}>
                    <SpotifyV1Header />
                    {<tbody>
                        <SpotifyV1Body />
                    </tbody>}
                </table>
            </div>
        )
    }

    const SpotifyV2Body = () => {
        return (
            matchedMusicData?.map((item, index) => {
                console.log("matchedMusicDataV2 : ", matchedMusicData);
                const { ArtistDetail, Albums, AllTracks, TopTracks, CSV } = item;
                return (
                    <tr key={ArtistDetail.id} onClick={() => {
                        setCurrentItem(item);
                        setOpenViewJSONDialog(true);
                    }}>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{index + 1}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{ArtistDetail?.id}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{ArtistDetail?.name}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{ArtistDetail?.popularity}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{
                            ArtistDetail?.followers?.total
                        }</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{
                            (ArtistDetail.genres || []).map((genre) => genre).join(', ')}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{AllTracks?.length}</td>
                        {/* <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>88</td>
                                    <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>
                                        &gt; Years (12)
                                        <br />
                                        &gt; Album (18)
                                    </td> */}
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>
                            <img
                                src={ArtistDetail?.images?.[0]?.url}
                                alt="Artist"
                                style={{ width: "50px", height: "75px", objectFit: "cover" }}
                            />
                        </td>
                    </tr>
                )
            })
        )
    }

    const SpotifyV2Header = () => {
        return (
            <thead>
                <tr style={{ backgroundColor: "#444", color: "white", fontWeight: "bold" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>S.No</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>ID</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Artist name</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Ranking</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Followers</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Genres</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Total Tracks</th>
                    {/* <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Total albums</th>
                                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Filters [Y/A]</th> */}
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Image</th>
                </tr>
            </thead>
        )
    }

    const SpotifyV2View = () => {
        return (
            <div style={{ overflowX: "auto", padding: "16px" }}>
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        minWidth: "1000px",
                    }}>
                    <SpotifyV2Header />
                    {<tbody>
                        <SpotifyV2Body />
                    </tbody>}
                </table>
            </div>
        )
    }

    const SpotifyMainView = () => {
        return (
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={spotifyTabIndex}
                    onChange={(event, newValue) => {
                        setSpotifyTabIndex(newValue);
                    }}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: '#000',
                            height: 3,
                        },
                    }}
                >
                    <Tab
                        label="Top Tracks (V1)"
                        sx={{
                            color: '#555',
                            '&.Mui-selected': {
                                color: '#000',
                                fontWeight: 'bold',
                            },
                            textTransform: 'none',
                            fontSize: '16px',
                            mx: 2, // optional spacing
                        }}
                    />
                    <Tab
                        label="Albums Tracks (V2)"
                        sx={{
                            color: '#555',
                            '&.Mui-selected': {
                                color: '#000',
                                fontWeight: 'bold',
                            },
                            textTransform: 'none',
                            fontSize: '16px',
                            mx: 2, // optional spacing
                        }}
                    />
                </Tabs>

                <Box sx={{ p: 2 }}>
                    {spotifyTabIndex === 0 && <SpotifyV1View />}
                    {spotifyTabIndex === 1 && <SpotifyV2View />}
                </Box>
            </Box>
        )
    }

    const JioSaavanTable = () => {
        return (
            <div style={{ overflowX: "auto", padding: "16px" }}>
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        minWidth: "1000px",
                    }}>
                    <JioSaavanV2Header />
                    {<tbody>
                        {(resultsJioSaavan && resultsJioSaavan?.length > 0) && <JioSaavanBody />}
                    </tbody>}
                </table>
            </div>
        );
    };

    const JioSaavanV2Header = () => {
        return (
            <thead>
                <tr style={{ backgroundColor: "#444", color: "white", fontWeight: "bold" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>S.No</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>ID</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Artist name</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Fan Count</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Followers</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Languages/Genres</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Total Tracks</th>
                    {/* <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Total albums</th>
                                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Filters [Y/A]</th> */}
                    <th style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>Image</th>
                </tr>
            </thead>
        )
    }

    const JioSaavanBody = () => {
        return (
            resultsJioSaavan?.map((item, index) => {
                const { CSV, allSongs, artist, artistDetails, artistId, matchedSongs, matchedTotalSongs, totalSongs, error } = item;
                const _songs = matchedSongs?.length > 0 ? matchedSongs : allSongs
                const _totalTracks = matchedSongs?.length > 0 ? matchedSongs?.length : allSongs?.length;
                return (
                    <tr key={artistDetails?.id} onClick={() => {
                        setCurrentItem({ CSV, artistDetails, totalTracks: _songs });
                        setOpenViewJSONDialog(true);
                    }}>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{index + 1}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{artistDetails?.id}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{artistDetails?.name}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{artistDetails?.fanCount}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{artistDetails?.followerCount}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{
                            (artistDetails.availableLanguages || []).map((genre) => genre).join(', ')}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>{_totalTracks}</td>
                        {/* <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>88</td>
                                    <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>
                                        &gt; Years (12)
                                        <br />
                                        &gt; Album (18)
                                    </td> */}
                        <td style={{ border: "1px solid #ccc", padding: "8px 12px", textAlign: "center" }}>
                            <img
                                src={artistDetails?.image?.[1]?.url}
                                alt="Artist"
                                style={{ width: "50px", height: "75px", objectFit: "cover" }}
                            />
                        </td>
                    </tr>
                )
            })
        )
    }

    const TMDBItemView = () => {
        return (
            matchedMoviesData?.map((item, index) => {
                const { tmdbDetail, tmdbResult, ...rest } = item;
                const newItem = rest;
                const detail = tmdbDetail;
                const result = tmdbResult;
                //console.log("detail : ",result)
                return (
                    <tr key={detail.id} onClick={() => {
                        setCurrentItem(detail);
                        setOpenViewJSONDialog(true);

                        //getQuestionsFromOpenAI(detail);
                        //getQuestionsFromMoviesListViaOpenAI(matchedMoviesData);
                        //setOpenAIQuestionDialog(true);
                    }}>
                        <td>{index + 1}</td>
                        <td>{detail.imdb_id}</td>
                        <td>{detail.title || detail.name}</td>
                        <td>{result.source.charAt(0).toUpperCase() + result.source.slice(1)}</td>
                        <td>{detail.release_date || detail.first_air_date}</td>
                        <td>{detail.original_language}</td>
                        <td>{detail.overview}</td>
                        <td>
                            {(detail.genres || [])
                                .map((genre) => genre.name)
                                .join(', ')}
                        </td>
                        <td>
                            <img
                                src={`https://image.tmdb.org/t/p/w200${detail.poster_path}`}
                                alt={detail.title || detail.name}
                                width="100"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    //console.log("detail-images : ",detail?.images);
                                    //console.log("detail?.images : ",item?.tmdbDetail?.images);
                                    setCurrentItemPosters(detail?.images);
                                    setOpenViewPostersDialog(true);
                                }}
                            />
                        </td>
                    </tr>
                );
            })
        );
    }


    const OMDBItemView = () => {
        //console.log("OMDBItemView : ",matchedMoviesData);
        return (matchedMoviesData?.map((item, index) => {
            console.log("matchedMoviesData.item : ", item);
            const { omdbResult, ...rest } = item;
            const newItem = rest;
            console.log("omdbResult : ", omdbResult)
            return (
                <tr key={omdbResult.imdbID} onClick={() => {
                    setCurrentItem(omdbResult);
                    setOpenViewJSONDialog(true);

                    getQuestionsFromOpenAI(omdbResult);
                    //getQuestionsFromMoviesListViaOpenAI(matchedMoviesData);
                    //setOpenAIQuestionDialog(true);
                }}>
                    <td>{index + 1}</td>
                    <td>{omdbResult.imdbID}</td>
                    <td>{omdbResult.Title || omdbResult.name}</td>
                    <td>{omdbResult?.Type?.charAt(0)?.toUpperCase() + omdbResult?.Type?.slice(1)}</td>
                    <td>{omdbResult.Released || omdbResult.first_air_date}</td>
                    <td>{omdbResult.Language}</td>
                    <td>{omdbResult.Plot}</td>
                    <td>{omdbResult.Genre}</td>
                    <td>
                        <img
                            src={`${omdbResult.Poster}`}
                            alt={omdbResult.Title || omdbResult.name}
                            width="100"
                            onClick={(e) => {
                                e.stopPropagation();
                                //console.log("detail-images : ",detail?.images);
                                //console.log("detail?.images : ",item?.tmdbDetail?.images);
                                console.log("poster data : ",omdbResult)
                                //setCurrentItemPosters(detail?.images);
                                //setOpenViewPostersDialog(true);
                            }}
                        />
                    </td>
                </tr>
            );
        })
        );
    }

    const TMDBTable = () => {
        return (
            <table border="1" cellPadding="8" cellSpacing="0" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ position: 'sticky', top: 0, backgroundColor: 'black', color: 'white', zIndex: 1 }}>
                    <tr>
                        <th>S.NO</th>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Type</th>
                        <th>Release Date</th>
                        <th>Language</th>
                        <th style={{ width: '300px' }}>Overview</th>
                        <th>Genres</th>
                        <th>Poster Image</th>
                    </tr>
                </thead>
                <tbody>
                    {title?.toUpperCase() === 'TMDB' && <TMDBItemView />}
                    {title?.toUpperCase() === 'OMDB' && <OMDBItemView />}
                </tbody>
            </table>
        );
    };

    return (
        <div style={styles.container}>
            <Box sx={{ flex: 1, height: "100%", padding: 4, marginTop: 2 }}>

                {/* Title + Create + Update button in a row */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 4,
                    }}
                >
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 0,
                        px: 2
                    }}>
                        <Typography variant="h4" fontWeight={"bold"}>{title}</Typography>
                    </Box>

                    {/* UPLOAD */}
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 0,
                        px: 2
                    }}>
                        <>
                            <Button
                                variant="contained"
                                color="success"
                                sx={{ borderRadius: 2, textTransform: 'none', px: 4 }}
                                onClick={handleOnCSVUploadClick}
                            >
                                {title} Upload CSV
                            </Button>

                            <input
                                type="file"
                                accept=".csv"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                        </>

                        {/* DOWNLOAD */}
                        {(matchedMoviesData?.length > 0 || matchedMusicData?.length > 0 || resultsJioSaavan?.length > 0) && <Button
                            variant="contained"
                            color="success"
                            sx={{ borderRadius: 2, textTransform: "none", px: 4, ml: 4 }}
                            onClick={() => {
                                if (matchedMoviesData?.length > 0) {
                                    handleDownloadAsJson(matchedMoviesData)
                                }
                                if (matchedMusicData?.length > 0) {
                                    handleDownloadAsJson(matchedMusicData)
                                }
                                if (resultsJioSaavan?.length > 0) {
                                    handleDownloadAsJson(resultsJioSaavan)
                                }
                            }}
                        >
                            Download Matched as JSON
                        </Button>}

                        {(unMatchedMoviesData?.length > 0 || unMatchedMusicData?.length > 0 || errorResultJioSaavan?.length > 0) && <Button
                            variant="contained"
                            color="error"
                            sx={{ borderRadius: 2, textTransform: "none", px: 4, ml: 4 }}
                            onClick={() => {
                                if (unMatchedMoviesData?.length > 0) {
                                    handleDownloadAsJson(unMatchedMoviesData)
                                }
                                if (unMatchedMusicData?.length > 0) {
                                    handleDownloadAsJson(unMatchedMusicData)
                                }
                                if (errorResultJioSaavan?.length > 0) {
                                    handleDownloadAsJson(errorResultJioSaavan);
                                }
                            }}
                        >
                            Download UnMatched as JSON
                        </Button>}

                        {(unMatchedMoviesData?.length > 0 || unMatchedMusicData?.length > 0 || errorResultJioSaavan?.length > 0) && <Button
                            variant="contained"
                            color="error"
                            sx={{ borderRadius: 2, textTransform: "none", px: 4, ml: 4 }}
                            onClick={() => {
                                setOpenViewUnMachedDialog(true);
                            }}
                        >
                            View UnMatched
                        </Button>}
                    </Box>

                </Box>
                {loading ?
                    (<Box display="flex" justifyContent="center" alignItems="center" minHeight="150px">
                        <CircularProgress size={40}
                            thickness={4}
                            sx={{
                                color: '#007AFF',
                            }} />
                    </Box>) :
                    (<Box sx={{ p: 2 }}>
                        {matchedMoviesData?.length > 0 && <TMDBTable />}
                        {(matchedMusicData?.length > 0) && <SpotifyMainView />}
                        {(resultsJioSaavan?.length > 0 || resultsJioSaavan?.length > 0) && <JioSaavanTable />}
                    </Box>)}
            </Box>
            {(unMatchedMoviesData?.length > 0 || unMatchedMusicData?.length > 0 || errorResultJioSaavan?.length > 0) && <UnmatchedMoviesDialog
                openViewUnMachedDialog={openViewUnMachedDialog}
                onClose={() => setOpenViewUnMachedDialog(false)}
                unmatchedMovies={unMatchedMoviesData?.length > 0
                    ? unMatchedMoviesData
                    : (unMatchedMusicData?.length > 0 ? unMatchedMoviesData : errorResultJioSaavan)}
            />}
            {currentItemPosters && <PosterGridDialog open={openViewPostersDialog} onClose={() => setOpenViewPostersDialog(false)} currentItemPosters={currentItemPosters} />}
            {currentItem && <JsonViewerDialog open={openViewJSONDialog} onClose={() => setOpenViewJSONDialog(false)} jsonData={currentItem} />}
            {(openAIGeneratedQuestion && openAIGeneratedQuestion?.length > 0) && <OpenAIQuestionDialog open={openAIQuestionDialog} onClose={() => {
                setOpenAIGeneratedQuestion([])
                setOpenAIQuestionDialog(false)
            }
            } questions={openAIGeneratedQuestion} />}
        </div>
    );
}

// Simple inline styles
const styles = {
    container: {
        padding: '40px',
        textAlign: 'center',
    },
    title: {
        fontSize: '36px',
        marginBottom: '10px',
    },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => ({

});

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = (dispatch) => ({

});

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(DataPipeline);